import moment from 'moment'

export const DateStringFormat = dateString => {
  return moment(dateString, 'DD/MM/YYYY').format('YYYY-MM-DD')
}

export const DateStringFormatToBr = dateString => {
  return moment(dateString, 'YYYY-MM-DD').format('DD/MM/YYYY')
}
